<div>
  <div *ngFor="let chip of chips" class="selectable-chip"
       [class.selectable-chip__selected]="isSelected(chip)"
       (click)="allowDeselect?toggleChip(chip):selectChip(chip)"
       matRipple>
    {{labelMapper ? labelMapper(chip) : chip}}
  </div>
</div>
